import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import qrcode from "qrcode-js";
import * as XLSX from "xlsx";
import { v4 as uuidv4 } from "uuid";

function ListadoArticulos() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_LINEAS = process.env.REACT_APP_URL_LINEAS;
  const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;
  const URL_FAMILIAS = process.env.REACT_APP_URL_FAMILIAS;
  const URL_UNIDADES_NEGOCIO = process.env.REACT_APP_URL_UNIDADES_NEGOCIO;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_VARIANTES_ARTICULOS = process.env.REACT_APP_URL_VARIANTES_ARTICULOS;

  const [articulos, setArticulos] = useState("");
  const [activo, setActivo] = useState("");

  const [codigo, setCodigo] = useState("");
  const [codigoSAT, setCodigoSAT] = useState("");
  const [clave, setClave] = useState("");
  const [nombre, setNombre] = useState("");
  const [modelo, setModelo] = useState("");
  const [piezasPorCaja, setPiezasPorCaja] = useState("");
  const [costoUSD, setCostoUSD] = useState("");
  // const [costoCNY, setCostoCNY] = useState(0);
  const [costoMX, setCostoMX] = useState("");
  const [venta, setVenta] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [EAN, setEAN] = useState("NA");
  const [SKU, setSKU] = useState("NA");
  const [MLM, setMLM] = useState("NA");
  const [ASIN, setASIN] = useState("NA");
  const [WUPC, setWUPC] = useState("NA");
  const [linkML, setLinkML] = useState("");
  const [linkShein, setLinkShein] = useState("");
  const [linkAmazon, setLinkAmazon] = useState("");
  const [linkCoppel, setLinkCoppel] = useState("");
  const [linkLiverpool, setLinkLiverpool] = useState("");
  const [linkWalmart, setLinkWalmart] = useState("");
  const [linkElektra, setLinkElektra] = useState("");

  const [imagenes, setImagenes] = useState("");
  const [especiales, setEspeciales] = useState("");
  const [cargadoML, setCargadoML] = useState("");
  const [cargadoShein, setCargadoShein] = useState("");
  const [cargadoAmazon, setCargadoAmazon] = useState("");
  const [cargadoCoppel, setCargadoCoppel] = useState("");
  const [cargadoWalmart, setCargadoWalmart] = useState("");
  const [cargadoLiverpool, setCargadoLiverpool] = useState("");
  const [cargadoElektra, setCargadoElektra] = useState("");

  const [largoProducto, setLargoProducto] = useState(0);
  const [anchoProducto, setAnchoProducto] = useState(0);
  const [altoProducto, setAltoProducto] = useState(0);
  const [pesoProducto, setPesoProducto] = useState(0);
  const [largoEmpaque, setLargoEmpaque] = useState(0);
  const [anchoEmpaque, setAnchoEmpaque] = useState(0);
  const [altoEmpaque, setAltoEmpaque] = useState(0);
  const [pesoEmpaque, setPesoEmpaque] = useState(0);
  const [largoMaster, setLargoMaster] = useState(0);
  const [anchoMaster, setAnchoMaster] = useState(0);
  const [altoMaster, setAltoMaster] = useState(0);
  const [pesoMaster, setPesoMaster] = useState(0);
  const [stockMinimo, setStockMinimo] = useState(0);
  const [stockMaximo, setStockMaximo] = useState(0);
  const [indiceRotacion, setIndiceRotacion] = useState(0);

  const [lineas, setLineas] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [familias, setFamilias] = useState([]);
  const [unidadesNegocio, setUnidadesNegocio] = useState([]);
  const [proveedores, setProveedores] = useState([]);


  const [selectedCodigo, setSelectedCodigo] = useState(0);
  const [selectedNombre, setSelectedNombre] = useState(0);
  const [selectedLinea, setSelectedLinea] = useState(0);
  const [selectedMarca, setSelectedMarca] = useState(0);
  const [selectedFamilia, setSelectedFamilia] = useState(0);
  const [selectedUnidadNegocio, setSelectedUnidadNegocio] = useState(0);
  const [selectedProveedor, setSelectedProveedor] = useState(0);

  const [selectedLineaEdit, setSelectedLineaEdit] = useState("");
  const [selectedMarcaEdit, setSelectedMarcaEdit] = useState("");
  const [selectedFamiliaEdit, setSelectedFamiliaEdit] = useState("");
  const [selectedUnidadNegocioEdit, setSelectedUnidadNegocioEdit] = useState("");
  const [selectedProveedorEdit, setSelectedProveedorEdit] = useState("");
  const [selectedActivo, setSelectedActivo] = useState("Si");
  const [idEditArticulo, setIdEditArticulo] = useState("");

  const [lista1, setLista1] = useState(0);
  const [lista2, setLista2] = useState(0);
  const [lista3, setLista3] = useState(0);
  const [lista4, setLista4] = useState(0);
  const [lista1Bruto, setLista1Bruto] = useState(0);
  const [lista2Bruto, setLista2Bruto] = useState(0);
  const [lista3Bruto, setLista3Bruto] = useState(0);
  const [lista4Bruto, setLista4Bruto] = useState(0);
    const [comision, setComision] = useState(0);
    const [otrosCostos, setOtrosCostos] = useState(0);

    const [validaBoton, setValidaBoton] = useState(false);
    const [cargando, setCargando] = useState(false);

  const [variantesFields, setVariantesFields] = useState([]);
  const [variantesOriginales, setVariantesOriginales] = useState([]);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [modalCotizador, setModalCotizador] = useState(false);
  const toggleCotizador = () => setModalCotizador(!modalCotizador);
  const [cotizador, setCotizador] = useState({
  sku: "",
  piezasPorCaja: "",
  cbmCaja: "",
  precioFob: "",
  cbmContenedor: "",
  fleteMaritimo: "",
  impuestos: "",
  tipoCambio: "",
  venta: "",
  envio: "",
  comision: "",
});

  let hoy = new Date();
  hoy.setDate(hoy.getDate() - 3650);
  const year = hoy.getFullYear();
  const years = Array.from(new Array(12), (val, index) => index + year);

  const [file, setFile] = useState();
  const [photo, setPhoto] = useState();
  const URL_FILEPOST = process.env.REACT_APP_URL_UPPROFILE;

  const [modalFoto, setModalFoto] = useState(false);
  const toggleFoto = () => setModalFoto(!modalFoto);


  const [totalCaptura, setTotalCaptura] = useState(1);
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      fob: 0,
      venta: 0
    },
  ]);
  const [modalDatos, setModalDatos] = useState(false);
  const toggleDatos = () => setModalDatos(!modalDatos);
  const [modalCostos, setModalCostos] = useState(false);
  const toggleCostos = () => setModalCostos(!modalCostos);
  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  function addTagEdit(vfId, field, value) {
    const trimmed = value.trim();
    if (!trimmed) return;
    setVariantesFields((prev) =>
      prev.map((v) => v.id === vfId ? { ...v, [field]: [...v[field], trimmed] } : v)
    );
  }
  function removeTagEdit(vfId, field, index) {
    setVariantesFields((prev) =>
      prev.map((v) => v.id === vfId ? { ...v, [field]: v[field].filter((_, i) => i !== index) } : v)
    );
  }

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useEffect(() => {
    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        // Array para pagination
        let arrayTabla = allArticulos
          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              activo: a.is_active,
              codigo: a.codigo,
              codigoSAT: a.codigoSAT,
              clave: a.clave,
              nombre: a.nombre,
              modelo: a.modelo,
              piezasPorCaja: a.piezasPorCaja,
              costoUSD: a.costoUSD,
              // costoCNY: a.costoCNY,
              costoMX: a.costoMX,
              venta: a.venta,
              observaciones: a.observaciones,
              EAN: a.EAN,
              SKU: a.SKU,
              WUPC: a.WUPC,
              MLM: a.MLM,
              ASIN: a.ASIN,
              imagenes: a.imagenes,
              especiales: a.especiales,
              linkML: a.linkML,
              linkShein: a.linkShein,
              linkAmazon: a.linkAmazon,
              linkCoppel: a.linkCoppel,
              linkWalmart: a.linkWalmart,
              linkLiverpool: a.linkLiverpool,
              linkElektra: a.linkElektra,
              cargadoML: a.cargadoML,
              cargadoShein: a.cargadoShein,
              cargadoAmazon: a.cargadoAmazon,
              cargadoCoppel: a.cargadoCoppel,
              cargadoWalmart: a.cargadoWalmart,
              cargadoLiverpool: a.cargadoLiverpool,
              cargadoElektra: a.cargadoElektra,
              largoProducto: a.largoProducto,
              anchoProducto: a.anchoProducto,
              altoProducto: a.altoProducto,
              pesoProducto: a.pesoProducto,
              largoEmpaque: a.largoEmpaque,
              anchoEmpaque: a.anchoEmpaque,
              altoEmpaque: a.altoEmpaque,
              pesoEmpaque: a.pesoEmpaque,
              largoMaster: a.largoMaster,
              anchoMaster: a.anchoMaster,
              altoMaster: a.altoMaster,
              pesoMaster: a.pesoMaster,
              stockMinimo: a.stockMinimo,
              stockMaximo: a.stockMaximo,
              indiceRotacion: a.indiceRotacion,
              linea: a.lineas?.[0]?.name || "",
              marca: a.marcas?.[0]?.name || "",
              familia: a.familias?.[0]?.name || "",
              unidadNegocio: a.unidadesNegocio?.[0]?.name || "",
              proveedor: a.proveedores?.[0]?.nombre_comercial || "",
              idLinea: a.lineas?.[0]?._id || "",
              idMarca: a.marcas?.[0]?._id || "",
              idFamilia: a.familias?.[0]?._id || "",
              idUnidadNegocio: a.unidadesNegocio?.[0]?._id || "",
              idProveedor: a.proveedores?.[0]?._id || "",
              lista1: a.lista1,
              lista2: a.lista2,
              lista3: a.lista3,
              lista4: a.lista4,
              lista1Bruto: a.lista1Bruto,
              lista2Bruto: a.lista2Bruto,
              lista3Bruto: a.lista3Bruto,
              lista4Bruto: a.lista4Bruto,
              comision: a.comision,
              otrosCostos: a.otrosCostos
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setArticulos(allArticulos);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_LINEAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allLineas = res.data;
        setLineas(allLineas);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_MARCAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allMarcas = res.data;
        setMarcas(allMarcas);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_FAMILIAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allFamilias = res.data;
        setFamilias(allFamilias);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_UNIDADES_NEGOCIO, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allUnidadesNegocio = res.data;
        setUnidadesNegocio(allUnidadesNegocio);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
    .get(`${URL_PROVEEDORES}Tipo/China`, { 
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allProveedores = res.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (!idEditArticulo) return;
    axios
      .get(`${URL_VARIANTES_ARTICULOS}/articulo/${idEditArticulo}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => {
        const loaded = res.data.map((v) => ({
          id: v._id,
          _id: v._id,
          nombre: v.nombre,
          ASIN: v.ASIN || [],
          WUPC: v.WUPC || [],
          MLM: v.MLM || [],
        }));
        setVariantesFields(loaded);
        setVariantesOriginales(loaded.map((v) => v._id));
      })
      .catch((err) => console.log(err));
  }, [idEditArticulo]);

  const ListaArticulos = comments.sort((a, b) =>
    a.nombre > b.nombre ? 1 : -1
  );

  function PDFTabla() {
    const data = ListaArticulos.map((a) => {
      if (
        (selectedLinea == 0 || selectedLinea == a.idLinea) &&
        (selectedMarca == 0 || selectedMarca == a.idMarca) &&
        (selectedFamilia == 0 || selectedFamilia == a.idFamilia) &&
        (selectedUnidadNegocio == 0 || selectedUnidadNegocio == a.idUnidadNegocio) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedor) &&
        (selectedActivo == 0 || selectedActivo == a.activo)
      ) {
        return [
          a.codigo,
          a.nombre,
          a.piezasPorCaja,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.costoUSD),
          // new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.costoMX),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.venta),
          a.linea,
          a.marca,
          // a.familia,
          a.unidadNegocio,
          a.proveedor,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 125, 10, 40, 30);
    doc.text(`Listado Articulos`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Codigo",
          "Modelo",
          "Pzas x Caja",
          "FOB USD",
          // "Costo MX",
          "Venta",
          "Linea",
          "Marca",
          // "Familia",
          "UnidadNegocio",
          "Proveedor",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    window.open(doc.output("bloburl"), "_blank");
  }

function excel() {
  // 1. Filtrado por campos seleccionados
  let filteredArticulos = ListaArticulos.filter((a) =>
    (selectedLinea == 0 || selectedLinea == a.idLinea) &&
    (selectedMarca == 0 || selectedMarca == a.idMarca) &&
    (selectedFamilia == 0 || selectedFamilia == a.idFamilia) &&
    (selectedUnidadNegocio == 0 || selectedUnidadNegocio == a.idUnidadNegocio) &&
    (selectedProveedor == 0 || selectedProveedor == a.idProveedor) &&
    (selectedActivo == 0 || selectedActivo == a.activo)
  );

  // 2. Filtro de búsqueda
  if (search && search.trim() !== "") {
    const searchLower = search.toLowerCase();
    filteredArticulos = filteredArticulos.filter((a) =>
      (a._id && a._id.toLowerCase().includes(searchLower)) ||
      (a.SKU && a.SKU.toLowerCase().includes(searchLower)) ||
      (a.ASIN && a.ASIN.toLowerCase().includes(searchLower)) ||
      (a.clave && a.clave.toLowerCase().includes(searchLower)) ||
      (a.nombre && a.nombre.toLowerCase().includes(searchLower)) ||
      (a.linea && a.linea.toLowerCase().includes(searchLower)) ||
      (a.marca && a.marca.toLowerCase().includes(searchLower)) ||
      (a.unidadNegocio && a.unidadNegocio.toLowerCase().includes(searchLower)) ||
      (a.proveedor && a.proveedor.toLowerCase().includes(searchLower)) ||
      (a.piezasPorCaja != null && a.piezasPorCaja.toString().includes(searchLower))
    );
  }

  // 3. Mapeo de los datos a exportar
  const dataExcel = filteredArticulos.map((a) => ({
    Id: a._id,
    Parent: a.SKU,
    WUPC: a.WUPC,
    MLM: a.MLM,
    ASIN: a.ASIN,
    Clave: a.clave,
    EAN: a.EAN,
    Nombre: a.nombre,
    lista1Neto: a.lista1,
    lista2Neto: a.lista2,
    lista3Neto: a.lista3,
    lista4Neto: a.lista4,
    lista1Bruto: a.lista1Bruto,
    lista2Bruto: a.lista2Bruto,
    lista3Bruto: a.lista3Bruto,
    lista4Bruto: a.lista4Bruto,
    Comision: a.comision,
    OtrosCostos: a.otrosCostos,
    largoProducto: a.largoProducto,
    anchoProducto: a.anchoProducto,
    altoProducto: a.altoProducto,
    pesoProducto: a.pesoProducto,
    largoEmpaque: a.largoEmpaque,
    anchoEmpaque: a.anchoEmpaque,
    altoEmpaque: a.altoEmpaque,
    pesoEmpaque: a.pesoEmpaque,
    largoMaster: a.largoMaster,
    anchoMaster: a.anchoMaster,
    altoMaster: a.altoMaster,
    pesoMaster: a.pesoMaster,
    piezasPorCaja: a.piezasPorCaja,
    Linea: a.linea,
    Marca: a.marca,
    UnidadNegocio: a.unidadNegocio,
    Proveedor: a.proveedor,
  }));

  const dataExcelLimpia = dataExcel.filter((el) => el != null);

  const option = {
    fileName: "ListadoArticulos",
    datas: [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoArticulos",
        sheetFilter: [
          "Id", "Parent", "WUPC", "MLM", "ASIN", "Clave", "UPC", "Nombre",
          "lista1Neto", "lista2Neto", "lista3Neto", "lista4Neto",
          "lista1Bruto", "lista2Bruto", "lista3Bruto", "lista4Bruto",
          "Comision", "OtrosCostos",
          "largoProducto", "anchoProducto", "altoProducto", "pesoProducto",
          "largoEmpaque", "anchoEmpaque", "altoEmpaque", "pesoEmpaque",
          "largoMaster", "anchoMaster", "altoMaster", "pesoMaster",
          "piezasPorCaja", "Linea", "Marca", "Proveedor"
        ],
        sheetHeader: [
          "Id", "Parent", "WUPC", "MLM", "ASIN", "Clave", "UPC", "Nombre",
          "lista1Neto", "lista2Neto", "lista3Neto", "lista4Neto",
          "lista1Bruto", "lista2Bruto", "lista3Bruto", "lista4Bruto",
          "Comision", "OtrosCostos",
          "largoProducto", "anchoProducto", "altoProducto", "pesoProducto",
          "largoEmpaque", "anchoEmpaque", "altoEmpaque", "pesoEmpaque",
          "largoMaster", "anchoMaster", "altoMaster", "pesoMaster",
          "piezasPorCaja", "Linea", "Marca", "Proveedor"
        ],
      },
    ],
  };

  const toExcel = new ExportJsonExcel(option);
  toExcel.saveExcel();
}


function excelCostos() {
  // 1. Filtrado por campos seleccionados
  let filteredArticulos = ListaArticulos.filter((a) =>
    (selectedLinea == 0 || selectedLinea == a.idLinea) &&
    (selectedMarca == 0 || selectedMarca == a.idMarca) &&
    (selectedFamilia == 0 || selectedFamilia == a.idFamilia) &&
    (selectedUnidadNegocio == 0 || selectedUnidadNegocio == a.idUnidadNegocio) &&
    (selectedProveedor == 0 || selectedProveedor == a.idProveedor) &&
    (selectedActivo == 0 || selectedActivo == a.activo)
  );

  // 2. Filtro de búsqueda
  if (search && search.trim() !== "") {
    const searchLower = search.toLowerCase();
    filteredArticulos = filteredArticulos.filter((a) =>
      (a._id && a._id.toLowerCase().includes(searchLower)) ||
      (a.SKU && a.SKU.toLowerCase().includes(searchLower)) ||
      (a.MLM && a.MLM.toLowerCase().includes(searchLower)) ||
      (a.ASIN && a.ASIN.toLowerCase().includes(searchLower)) ||
      (a.clave && a.clave.toLowerCase().includes(searchLower)) ||
      (a.nombre && a.nombre.toLowerCase().includes(searchLower)) ||
      (a.linea && a.linea.toLowerCase().includes(searchLower)) ||
      (a.marca && a.marca.toLowerCase().includes(searchLower)) ||
      (a.unidadNegocio && a.unidadNegocio.toLowerCase().includes(searchLower)) ||
      (a.proveedor && a.proveedor.toLowerCase().includes(searchLower))
    );
  }

  // 3. Mapeo de datos a exportar
  const dataExcel = filteredArticulos.map((a) => ({
    Id: a._id,
    Parent: a.SKU,
    WUPC: a.WUPC,
    MLM: a.MLM,
    ASIN: a.ASIN,
    Clave: a.clave,
    Nombre: a.nombre,
    FOBUSD: a.costoUSD,
    CostoMX: a.costoMX,
    Linea: a.linea,
    Marca: a.marca,
    UnidadNegocio: a.unidadNegocio,
    Proveedor: a.proveedor,
  }));

  const dataExcelLimpia = dataExcel.filter((el) => el != null);

  const option = {
    fileName: "ListadoArticulos",
    datas: [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoArticulos",
        sheetFilter: [
          "Id", "Parent", "WUPC", "MLM", "ASIN", "Clave", "Nombre",
          "FOBUSD", "CostoMX",
          "Linea", "Marca", "Proveedor"
        ],
        sheetHeader: [
          "Id", "Parent", "WUPC", "MLM", "ASIN", "Clave", "Nombre",
          "FOBUSD", "CostoMX",
          "Linea", "Marca", "Proveedor"
        ],
      },
    ],
  };

  const toExcel = new ExportJsonExcel(option);
  toExcel.saveExcel();
}


  function enviaMail() {
    const data = ListaArticulos.map((a) => {
      if (
        (selectedLinea == 0 || selectedLinea == a.idLinea) &&
        (selectedMarca == 0 || selectedMarca == a.idMarca) &&
        (selectedFamilia == 0 || selectedFamilia == a.idFamilia) &&
        (selectedUnidadNegocio == 0 || selectedUnidadNegocio == a.idUnidadNegocio) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedor) &&
        (selectedActivo == 0 || selectedActivo == a.activo)
      ) {
        return [
          a.codigo,
          a.nombre,
          a.piezasPorCaja,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.costoUSD),
          // new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.costoMX),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.venta),
          a.linea,
          a.marca,
          // a.familia,
          a.unidadNegocio,
          a.proveedor,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 125, 10, 40, 30);
    doc.text(`Listado Articulos`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Codigo",
          "Modelo",
          "Pzas x Caja",
          "FOB USD",
          // "Costo MX",
          "Venta",
          "Linea",
          "Marca",
          // "Familia",
          "UnidadNegocio",
          "Proveedor",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Articulos",
          email: mailTo,
          fileName: "ListadoArticulos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Articulos.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  
  function jalaFoto(
    idEdit
  ) {
    setPhoto("")
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_GETMEDIA}/${idEdit}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        if (data.data.version) {
          setPhoto(data.data.version);
        }
      })
      .catch((err) => console.log(err));


    setIdEditArticulo(idEdit);
    toggleFoto();
  }


  function jalaInfo(
   codigo,
   codigoSAT,
   clave,
   nombre,
   modelo,
   piezasPorCaja,
   costoUSD,
  //  costoCNY,
   costoMX,
   venta,
   observaciones,
   EAN,
   SKU,
    MLM,
   ASIN,
   WUPC,
   imagenes,
   especiales,
   linkML,
   linkShein,
   linkAmazon,
   linkCoppel,
   linkWalmart,
   linkLiverpool,
   linkElektra,
   cargadoML,
   cargadoShein,
   cargadoAmazon,
   cargadoCoppel,
   cargadoWalmart,
   cargadoLiverpool,
   cargadoElektra,
   largoProducto,
   anchoProducto,
   altoProducto,
   pesoProducto,
   largoEmpaque,
   anchoEmpaque,
   altoEmpaque,
   pesoEmpaque,
   largoMaster,
   anchoMaster,
   altoMaster,
   pesoMaster,
   stockMinimo,
   stockMaximo,
   indiceRotacion,


    idLinea,
    idMarca,
    idFamilia,
    idUnidadNegocio,
    idProveedor,
    lista1,
    lista2,
    lista3,
    lista4,
    lista1Bruto,
    lista2Bruto,
    lista3Bruto,
    lista4Bruto,
    comision,
    otrosCostos,
    idEdit
  ) {
    setCodigo(codigo);
    setCodigoSAT(codigoSAT);
    setClave(clave);
    setNombre(nombre);
    setModelo(modelo);
    setPiezasPorCaja(piezasPorCaja);
    setCostoUSD(costoUSD);
    // setCostoCNY(costoCNY);
    setCostoMX(costoMX);
    setVenta(venta);
    setObservaciones(observaciones);
    setEAN(EAN);
    setSKU(SKU);
    setMLM(MLM);
    setASIN(ASIN);
    setWUPC(WUPC);
    setImagenes(imagenes);
    setEspeciales(especiales);
    setLinkML(linkML);
    setLinkShein(linkShein);
    setLinkAmazon(linkAmazon);
    setLinkCoppel(linkCoppel);
    setLinkWalmart(linkWalmart);
    setLinkLiverpool(linkLiverpool);
    setLinkElektra(linkElektra);
    setCargadoML(cargadoML);
    setCargadoShein(cargadoShein);
    setCargadoAmazon(cargadoAmazon);
    setCargadoCoppel(cargadoCoppel);
    setCargadoWalmart(cargadoWalmart);
    setCargadoLiverpool(cargadoLiverpool);
    setCargadoElektra(cargadoElektra);
    setLargoProducto(largoProducto);
    setAnchoProducto(anchoProducto);
    setAltoProducto(altoProducto);
    setPesoProducto(pesoProducto);
    setLargoEmpaque(largoEmpaque);
    setAnchoEmpaque(anchoEmpaque);
    setAltoEmpaque(altoEmpaque);
    setPesoEmpaque(pesoEmpaque);
    setLargoMaster(largoMaster);
    setAnchoMaster(anchoMaster);
    setAltoMaster(altoMaster);
    setPesoMaster(pesoMaster);
    setStockMinimo(stockMinimo);
    setStockMaximo(stockMaximo);
    setIndiceRotacion(indiceRotacion);
    
    setSelectedLineaEdit(idLinea);
    setSelectedMarcaEdit(idMarca);
    setSelectedFamiliaEdit(idFamilia);
    setSelectedUnidadNegocioEdit(idUnidadNegocio);
    setSelectedProveedorEdit(idProveedor);
    setLista1(lista1)
    setLista2(lista2)
    setLista3(lista3)
    setLista4(lista4)
    setLista1Bruto(lista1Bruto)
    setLista2Bruto(lista2Bruto)
    setLista3Bruto(lista3Bruto)
    setLista4Bruto(lista4Bruto)
    setComision(comision)
    setOtrosCostos(otrosCostos)
    setIdEditArticulo(idEdit);
    toggleEdit();
  }

  function editArticulos(event) {
    event.preventDefault();
    const URL_ARTICULOS_EDIT = `${process.env.REACT_APP_URL_ARTICULOS}/${idEditArticulo}`;
    if (file == null) {
    axios
      .all([
        axios.patch(
          URL_ARTICULOS_EDIT,
          {
            codigo,
            codigoSAT,
            clave,
            nombre,
            modelo,
            piezasPorCaja,
            costoUSD,
            // costoCNY,
            costoMX,
            venta,
            observaciones,
            EAN,
            SKU,
            MLM,
            ASIN,
            WUPC,
            imagenes,
            especiales,
            linkML,
            linkShein,
            linkAmazon,
            linkCoppel,
            linkWalmart,
            linkLiverpool,
            linkElektra,
            cargadoML,
            cargadoShein,
            cargadoAmazon,
            cargadoCoppel,
            cargadoWalmart,
            cargadoLiverpool,
            cargadoElektra,
            largoProducto,
            anchoProducto,
            altoProducto,
            pesoProducto,
            largoEmpaque,
            anchoEmpaque,
            altoEmpaque,
            pesoEmpaque,
            largoMaster,
            anchoMaster,
            altoMaster,
            pesoMaster,
            stockMinimo,
            stockMaximo,
            indiceRotacion,
            lineas: selectedLineaEdit,
            marcas: selectedMarcaEdit,
            familias: selectedFamiliaEdit,
            unidadesNegocio: selectedUnidadNegocioEdit,
            proveedores: selectedProveedorEdit,
            lista1,
            lista2,
            lista3,
            lista4,
            lista1Bruto,
            lista2Bruto,
            lista3Bruto,
            lista4Bruto,
            comision,
            otrosCostos
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        ),
      ])
      .then(() => {
        const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
        const currentIds = variantesFields.filter((v) => v._id).map((v) => v._id);
        const deletedIds = variantesOriginales.filter((id) => !currentIds.includes(id));
        const varianteOps = [
          ...deletedIds.map((id) =>
            axios.delete(`${URL_VARIANTES_ARTICULOS}/${id}`, { headers })
          ),
          ...variantesFields.map((v) =>
            v._id
              ? axios.patch(`${URL_VARIANTES_ARTICULOS}/${v._id}`, { nombre: v.nombre, ASIN: v.ASIN, WUPC: v.WUPC, MLM: v.MLM }, { headers })
              : axios.post(URL_VARIANTES_ARTICULOS, { articulos: idEditArticulo, nombre: v.nombre, ASIN: v.ASIN, WUPC: v.WUPC, MLM: v.MLM }, { headers })
          ),
        ];
        Promise.all(varianteOps).then(() => {
          axios.post(
            URL_LOGS,
            {
              tipo: "Editar Articulo",
              detalle: `${nombre} ${codigo}`,
              user: user.id,
            },
            { headers }
          );
          toggleEdit();
          Swal.fire("Good job!", "Actualizado con exito", "success");
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    } else{
      axios
      .all([
        axios.patch(
          URL_ARTICULOS_EDIT,
          {
            codigo,
            codigoSAT,
            clave,
            nombre,
            modelo,
            piezasPorCaja,
            costoUSD,
            // costoCNY,
            costoMX,
            venta,
            observaciones,
            EAN,
            SKU,
            MLM,
            ASIN,
            WUPC,
            imagenes,
            especiales,
            linkML,
            linkShein,
            linkAmazon,
            linkCoppel,
            linkWalmart,
            linkLiverpool,
            linkElektra,
            cargadoML,
            cargadoShein,
            cargadoAmazon,
            cargadoCoppel,
            cargadoWalmart,
            cargadoLiverpool,
            cargadoElektra,
            largoProducto,
            anchoProducto,
            altoProducto,
            pesoProducto,
            largoEmpaque,
            anchoEmpaque,
            altoEmpaque,
            pesoEmpaque,
            largoMaster,
            anchoMaster,
            altoMaster,
            pesoMaster,
            stockMinimo,
            stockMaximo,
            indiceRotacion,
            lineas: selectedLineaEdit,
            marcas: selectedMarcaEdit,
            familias: selectedFamiliaEdit,
            unidadesNegocio: selectedUnidadNegocioEdit,
            proveedores: selectedProveedorEdit,
            lista1,
            lista2,
            lista3,
            lista4,
            lista1Bruto,
            lista2Bruto,
            lista3Bruto,
            lista4Bruto,
            comision,
            otrosCostos
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        ),
      ])
      .then(() => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("articulo", idEditArticulo);

        axios
          .post(URL_FILEPOST, formData, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then(() => {
            const headers2 = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
            const currentIds2 = variantesFields.filter((v) => v._id).map((v) => v._id);
            const deletedIds2 = variantesOriginales.filter((id) => !currentIds2.includes(id));
            const varianteOps2 = [
              ...deletedIds2.map((id) => axios.delete(`${URL_VARIANTES_ARTICULOS}/${id}`, { headers: headers2 })),
              ...variantesFields.map((v) =>
                v._id
                  ? axios.patch(`${URL_VARIANTES_ARTICULOS}/${v._id}`, { nombre: v.nombre, ASIN: v.ASIN, WUPC: v.WUPC, MLM: v.MLM }, { headers: headers2 })
                  : axios.post(URL_VARIANTES_ARTICULOS, { articulos: idEditArticulo, nombre: v.nombre, ASIN: v.ASIN, WUPC: v.WUPC, MLM: v.MLM }, { headers: headers2 })
              ),
            ];
            Promise.all(varianteOps2).then(() => {
              axios.post(
                URL_LOGS,
                {
                  tipo: "Editar Articulo",
                  detalle: `${nombre} ${codigo}`,
                  user: user.id,
                },
                { headers: headers2 }
              );
              toggleEdit();
              Swal.fire("Good job!", "Actualizado con exito", "success");
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.log(error);
      });
  }
}
  const headers = [
    { name: "Activo", field: "activo", sortable: true },
    { name: "Parent", field: "SKU", sortable: true },
    { name: "WUPC", field: "WUPC", sortable: true },
    { name: "ASIN", field: "ASIN", sortable: true },
    { name: "Clave", field: "clave", sortable: true },
    { name: "Nombre", field: "nombre", sortable: true },
    { name: "Variante", field: "modelo", sortable: true },
    { name: "Pzas Caja", field: "piezasPorCaja", sortable: true },
    // { name: "FOB USD", field: "costoUSD", sortable: true },
    // { name: "Costo MX", field: "costoMX", sortable: true },
    // { name: "Venta", field: "venta", sortable: true },
    { name: "Linea", field: "linea", sortable: true },
    { name: "Marca", field: "marca", sortable: true },
    // { name: "Familia", field: "familia", sortable: true },
    // { name: "Unidad Negocio", field: "unidadNegocio", sortable: true },
    { name: "Proveedor", field: "proveedor", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      const q = search.toLowerCase();
      computedComments = computedComments.filter(
        (comment) =>
          (comment._id          || "").toLowerCase().includes(q) ||
          (comment.SKU          || "").toLowerCase().includes(q) ||
          (comment.ASIN         || "").toLowerCase().includes(q) ||
          (comment.MLM          || "").toLowerCase().includes(q) ||
          (comment.clave        || "").toLowerCase().includes(q) ||
          (comment.nombre       || "").toLowerCase().includes(q) ||
          (comment.modelo       || "").toLowerCase().includes(q) ||
          (comment.linea        || "").toLowerCase().includes(q) ||
          (comment.marca        || "").toLowerCase().includes(q) ||
          (comment.unidadNegocio|| "").toLowerCase().includes(q) ||
          (comment.proveedor    || "").toLowerCase().includes(q) ||
          (comment.piezasPorCaja != null ? comment.piezasPorCaja.toString() : "").includes(q)
      );
    }
    if (selectedCodigo) {
      computedComments = computedComments.filter((e) =>
        e._id.includes(selectedCodigo)
      );
    }
    if (selectedNombre) {
      computedComments = computedComments.filter((e) =>
        e._id.includes(selectedNombre)
      );
    }
    if (selectedLinea) {
      computedComments = computedComments.filter((e) =>
        e.idLinea.includes(selectedLinea)
      );
    }
    if (selectedMarca) {
      computedComments = computedComments.filter((e) =>
        e.idMarca.includes(selectedMarca)
      );
    }
    // if (selectedFamilia) {
    //   computedComments = computedComments.filter((e) =>
    //     e.idFamilia.includes(selectedFamilia)
    //   );
    // }
    // filtro unidadNegocio eliminado
    if (selectedProveedor) {
      computedComments = computedComments.filter((e) =>
        e.idProveedor.includes(selectedProveedor)
      );
    }
    if (selectedActivo) {
      computedComments = computedComments.filter((e) =>
        e.activo.includes(selectedActivo)
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "piezasPorCaja" 
      // &&
      // sorting.field != "costoUSD" 
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "piezasPorCaja" 
        // ||
        // sorting.field == "costoUSD" 
      )
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "piezasPorCaja" 
        // ||
        // sorting.field == "costoUSD"
      )
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCodigo,
    selectedNombre,
    selectedLinea,
    selectedMarca,
    // selectedFamilia,
    selectedUnidadNegocio,
    selectedProveedor,
    selectedActivo,
  ]);

  function QRGen(idArt, SKU, nombre) {
    const doc = new jsPDF("landscape", "mm", [55, 40]);

    let codigoQR = idArt;
    var base64 = qrcode.toDataURL(codigoQR);
    var img3 = new Image();
    img3.src = base64;
    doc.addImage(img3, "png", 13, 14, 25, 25);
    doc.setFontSize(8);
    doc.text(`ID: ${idArt}`, 3, 4);
    doc.text(`Parent: ${SKU}`, 3, 7.5);

    // Función para dividir el texto en dos líneas si es necesario
    function splitTextIntoLines(text, maxLength) {
        if (text.length <= maxLength) {
            return [text]; // No es necesario dividir
        }
        const firstLine = text.slice(0, maxLength);
        const secondLine = text.slice(maxLength);
        return [firstLine, secondLine];
    }

    // Tamaño máximo de caracteres por línea
    const maxLineLength = 40; // Ajusta según tu necesidad

    // Divide el nombre en líneas si es necesario
    const nombreLines = splitTextIntoLines(nombre, maxLineLength);

    doc.text(nombreLines[0], 3, 11);
    if (nombreLines[1]) {
        doc.text(nombreLines[1], 3, 14.5); // Ajusta la posición vertical según tu necesidad
    }

    window.open(doc.output("bloburl"), "_blank");
}


    function importarArchivo(event){
      setCargando(true)
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    let hojas = [];
   
    if (name === "file") {
  
      let reader = new FileReader();
        reader.readAsArrayBuffer(target.files[0]);
        reader.onloadend = (e) => {
          var data = new Uint8Array(e.target.result);
          var workbook = XLSX.read(data, { type: "array" });
  
          workbook.SheetNames.forEach(function (sheetName) {
            // Here is your object
            var XL_row_object = XLSX.utils.sheet_to_json(
              workbook.Sheets[sheetName]
            );
            hojas.push({
              data: XL_row_object,
              sheetName,
            });
          });
  
          let A1 = hojas[0].data
  
          let TC = totalCaptura
          A1.map((a)=>{
             TC = TC + 1
            setTotalCaptura(TC)
          inputFields.push({
            id: uuidv4(),
            articulos: a.Id,
            // fob: a.FOBUSD,
            nombre: a.Nombre,
            lista1: a.lista1Neto,
            lista2: a.lista2Neto,
            lista3: a.lista3Neto,
            lista4: a.lista4Neto,
            lista1Bruto: a.lista1Bruto,
            lista2Bruto: a.lista2Bruto,
            lista3Bruto: a.lista3Bruto,
            lista4Bruto: a.lista4Bruto,
            comision: a.Comision,
            otrosCostos: a.OtrosCostos,
            largoProducto: a.largoProducto,
            anchoProducto: a.anchoProducto,
            altoProducto: a.altoProducto,
            pesoProducto: a.pesoProducto,
            largoEmpaque: a.largoEmpaque,
            anchoEmpaque: a.anchoEmpaque,
            altoEmpaque: a.altoEmpaque,
            pesoEmpaque: a.pesoEmpaque,
            largoMaster: a.largoMaster,
            anchoMaster: a.anchoMaster,
            altoMaster: a.altoMaster,
            pesoMaster: a.pesoMaster,
            piezasPorCaja: a.piezasPorCaja,
            // costoMX: a.CostoMX,
            SKU: a.SKU,
            MLM: a.MLM,
            ASIN: a.ASIN,
            clave: a.Clave,
            EAN: a.EAN
          })
          })
     // Una vez que se ha terminado de procesar todo
     setValidaBoton(true);
    //  setCargando(false)
        }
    }
  }
  // console.log("hola", inputFields)

function actualizaDatos(event){
  event.preventDefault();
    toggleProgreso();
    let totalPedido = inputFields.length
  inputFields.map((a)=>{
    axios
    .patch(
      `${URL_ARTICULOS}/${a.articulos}`,
      {
        costoUSD: a.fob,
        nombre: a.nombre,
        lista1: a.lista1,
        lista2: a.lista2,
        lista3: a.lista3,
        lista4: a.lista4,
        lista1Bruto: a.lista1Bruto,
        lista2Bruto: a.lista2Bruto,
        lista3Bruto: a.lista3Bruto,
        lista4Bruto: a.lista4Bruto,
        comision: a.comision,
        otrosCostos: a.otrosCostos,
        largoProducto: a.largoProducto,
        anchoProducto: a.anchoProducto,
        altoProducto: a.altoProducto,
        pesoProducto: a.pesoProducto,
        largoEmpaque: a.largoEmpaque,
        anchoEmpaque: a.anchoEmpaque,
        altoEmpaque: a.altoEmpaque,
        pesoEmpaque: a.pesoEmpaque,
        largoMaster: a.largoMaster,
        anchoMaster: a.anchoMaster,
        altoMaster: a.altoMaster,
        pesoMaster: a.pesoMaster,
        piezasPorCaja: a.piezasPorCaja,
        costoMX: a.costoMX,
        SKU: a.SKU,
        MLM: a.MLM,
        ASIN: a.ASIN,
        clave: a.clave,
        EAN: a.EAN
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem(
            "app_token"
          )}`,
        },
      }
    ).then(() => {
      totalPedido = totalPedido - 1;

      if (totalPedido == 1) {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Costos",
            detalle: "Costos Masivos",
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem(
                "app_token"
              )}`,
            },
          }
        );
        Swal.fire("Good job!", "Creado con exito", `success`);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    })
    // .catch((error) => {
    //   Swal.fire({
    //     icon: "error",
    //     title: "Oops...",
    //     text: "Something went wrong!",
    //     footer: `${error.response.data}`,
    //   });
    //   console.log(error);
    // });
  })
}

function importarArchivoCostos(event){
  setCargando(true)
const target = event.target;
const value = target.type === "checkbox" ? target.checked : target.value;
const name = target.name;
let hojas = [];

if (name === "file") {

  let reader = new FileReader();
    reader.readAsArrayBuffer(target.files[0]);
    reader.onloadend = (e) => {
      var data = new Uint8Array(e.target.result);
      var workbook = XLSX.read(data, { type: "array" });

      workbook.SheetNames.forEach(function (sheetName) {
        // Here is your object
        var XL_row_object = XLSX.utils.sheet_to_json(
          workbook.Sheets[sheetName]
        );
        hojas.push({
          data: XL_row_object,
          sheetName,
        });
      });

      let A1 = hojas[0].data

      let TC = totalCaptura
      A1.map((a)=>{
         TC = TC + 1
        setTotalCaptura(TC)
      inputFields.push({
        id: uuidv4(),
        articulos: a.Id,
        fob: a.FOBUSD,
        costoMX: a.CostoMX,
      })
      })
 // Una vez que se ha terminado de procesar todo
 setValidaBoton(true);
//  setCargando(false)
    }
}
}
// console.log("hola", inputFields)

function actualizaCostos(event){
event.preventDefault();
toggleProgreso();
let totalPedido = inputFields.length
inputFields.map((a)=>{
axios
.patch(
  `${URL_ARTICULOS}/${a.articulos}`,
  {
    costoUSD: a.fob,
    costoMX: a.costoMX,
  },
  {
    headers: {
      Authorization: `Bearer: ${localStorage.getItem(
        "app_token"
      )}`,
    },
  }
).then(() => {
  totalPedido = totalPedido - 1;

  if (totalPedido == 1) {
    axios.post(
      URL_LOGS,
      {
        tipo: "Editar Costos",
        detalle: "Costos Masivos",
        user: user.id,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem(
            "app_token"
          )}`,
        },
      }
    );
    Swal.fire("Good job!", "Creado con exito", `success`);
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }
})
// .catch((error) => {
//   Swal.fire({
//     icon: "error",
//     title: "Oops...",
//     text: "Something went wrong!",
//     footer: `${error.response.data}`,
//   });
//   console.log(error);
// });
})
}

const handleChangeCotizador = (e) => {
  const { name, value } = e.target;
  setCotizador((prev) => ({
    ...prev,
    [name]: value,
  }));
};

// helper para números
const num = (v) => {
  const n = parseFloat(v);
  return isNaN(n) ? 0 : n;
};

// Desestructuramos ya como número
const piezasPorCajaCotizador = num(cotizador.piezasPorCaja);
const cbmCajaCotizador = num(cotizador.cbmCaja);
const precioFobCotizador = num(cotizador.precioFob);
const cbmContenedorCotizador = num(cotizador.cbmContenedor);
const fleteMaritimoCotizador = num(cotizador.fleteMaritimo);
const impuestosCotizador = num(cotizador.impuestos);
const tipoCambioCotizador = num(cotizador.tipoCambio);
const ventaCotizador = num(cotizador.venta);
const envioCotizador = num(cotizador.envio);
const comisionCotizador = num(cotizador.comision);

// FÓRMULAS CON LOS NUEVOS NOMBRES
const cajasPorContenedorCotizador =
  cbmCajaCotizador > 0 ? cbmContenedorCotizador / cbmCajaCotizador : 0;

const piezasPorContenedorCotizador =
  cajasPorContenedorCotizador > 0
    ? cajasPorContenedorCotizador * piezasPorCajaCotizador
    : 0;

const totalImportacionCotizador = impuestosCotizador + fleteMaritimoCotizador;

const costoImportacionPorPiezaCotizador =
  piezasPorContenedorCotizador > 0
    ? totalImportacionCotizador / piezasPorContenedorCotizador
    : 0;

const costoTotalProductoDllsCotizador =
  costoImportacionPorPiezaCotizador + precioFobCotizador;

const costoTotalProductoPesosCotizador =
  tipoCambioCotizador * costoTotalProductoDllsCotizador;

const gastosCotizador = costoTotalProductoPesosCotizador * 1.05;

const tePaganCotizador =
  ventaCotizador - envioCotizador - comisionCotizador;

const utilidadCotizador = tePaganCotizador - gastosCotizador;

const margenCotizador =
  gastosCotizador > 0 ? tePaganCotizador / gastosCotizador : 0;

  const sec = { borderLeft: "4px solid #3b82f6", paddingLeft: 12, marginBottom: 8, color: "#1e3a8a", fontWeight: 600, fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.05em" };
  const block = { background: "#f8fafc", borderRadius: 8, padding: "14px 16px", marginBottom: 16 };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_articulos ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.articulos_create ? (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/ArticulosCreate"
                >
                  Nuevo Modelo
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nuevo Modelo
                </Button>
              )}
              {/* {user.articulos_create ? (
                <Button
                  size="sm"
                  color="warning"
                  onClick={() => setModalCotizador(true)}
                >
                  Cotizador
                </Button>
              ) : (
                <Button
                  size="sm"
                  color="warning"
                  disabled
                >
                  Cotizador
                </Button>
              )} */}
              <Button
                size="sm"
                href="/MenuArticulos"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
                {user.inventarios_costos ? (
                  <Button
                    size="sm"
                    className="btn"
                    color="primary"
                    onClick={excelCostos}
                  >
                    Excel $ <i class="far fa-file-excel"></i>
                  </Button>
                ) : undefined}

                {/* {user.inventarios_costos ? (
                  <Button
                    size="sm"
                    className="btn"
                    color="warning"
                    onClick={toggleCostos}
                  >
                    Act. Costos
                  </Button>
                ) : undefined}

                <Button
                  size="sm"
                  className="btn"
                  color="warning"
                  onClick={toggleDatos}
                >
                  Act. Datos
                </Button> */}
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Articulos</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Articulos</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedActivo}
                  onChange={(e) => {
                    setSelectedActivo(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Si">Si</option>
                  <option value="No">No</option>
                </Input>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td style={{ paddingTop: "0px" }}></td>
              {/* <td style={{ paddingTop: "0px" }}></td> */}
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedLinea}
                  onChange={(e) => {
                    setSelectedLinea(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {lineas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedMarca}
                  onChange={(e) => {
                    setSelectedMarca(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {marcas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td>
              {/* <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedFamilia}
                  onChange={(e) => {
                    setSelectedFamilia(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {familias
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td> */}
              {/* Unidad Negocio filter oculto */}
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedProveedor}
                  onChange={(e) => {
                    setSelectedProveedor(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {proveedores
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => {
                      return (
                        <option value={a._id}>{a.nombre_comercial}</option>
                      );
                    })}
                </Input>
              </td>
            </tr>
            <tbody>
              {commentsData.map((a) => {
                {
                  return (
                    <tr>
                      <td>{a.activo}</td>
                      <td>{a.SKU}</td>
                      <td>{a.WUPC}</td>
                      <td>{a.ASIN}</td>
                      <td>{a.clave}</td>
                      <td>{a.nombre}</td>
                      <td>{a.modelo}</td>
                      <td>{a.piezasPorCaja}</td>
                      {/* <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.costoUSD)}{" "}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.costoMX)}{" "}
                      </td> */}
                      {/* <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.venta)}{" "}
                      </td> */}
                      <td>{a.linea} </td>
                      <td>{a.marca} </td>
                      {/* <td>{a.familia} </td>*/}
                      {/* <td>{a.unidadNegocio} </td> */}
                      <td>{a.proveedor} </td>
                      <td>
                        {user.articulos_create ? (
                          <div>
                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) => jalaFoto(a._id)}
                            >
                              <i class="fas fa-camera"></i>
                            </Button>

                            <Button
                              size="sm"
                              className="btn"
                              color="success"
                              onClick={(e) =>
                                QRGen(
                                  a._id,
                                  a.SKU,
                                  a.nombre,
                                  a.piezasPorCaja,
                                  a.linea,
                                  a.marca,
                                  a.familia,
                                  a.unidadNegocio
                                )
                              }
                            >
                              <i class="fas fa-qrcode"></i>
                            </Button>

                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) =>
                                jalaInfo(
                                  a.codigo,
                                  a.codigoSAT,
                                  a.clave,
                                  a.nombre,
                                  a.modelo,
                                  a.piezasPorCaja,
                                  a.costoUSD,
                                  // a.costoCNY,
                                  a.costoMX,
                                  a.venta,
                                  a.observaciones,
                                  a.EAN,
                                  a.SKU,
                                  a.MLM,
                                  a.ASIN,
                                  a.WUPC,
                                  a.imagenes,
                                  a.especiales,
                                  a.linkML,
                                  a.linkShein,
                                  a.linkAmazon,
                                  a.linkCoppel,
                                  a.linkWalmart,
                                  a.linkLiverpool,
                                  a.linkElektra,
                                  a.cargadoML,
                                  a.cargadoShein,
                                  a.cargadoAmazon,
                                  a.cargadoCoppel,
                                  a.cargadoWalmart,
                                  a.cargadoLiverpool,
                                  a.cargadoElektra,
                                  a.largoProducto,
                                  a.anchoProducto,
                                  a.altoProducto,
                                  a.pesoProducto,
                                  a.largoEmpaque,
                                  a.anchoEmpaque,
                                  a.altoEmpaque,
                                  a.pesoEmpaque,
                                  a.largoMaster,
                                  a.anchoMaster,
                                  a.altoMaster,
                                  a.pesoMaster,

                                  a.stockMinimo,
                                  a.stockMaximo,
                                  a.indiceRotacion,
                                  a.idLinea,
                                  a.idMarca,
                                  a.idFamilia,
                                  a.idUnidadNegocio,
                                  a.idProveedor,
                                  a.lista1,
                                  a.lista2,
                                  a.lista3,
                                  a.lista4,
                                  a.lista1Bruto,
                                  a.lista2Bruto,
                                  a.lista3Bruto,
                                  a.lista4Bruto,
                                  a.comision,
                                  a.otrosCostos,
                                  a._id
                                )
                              }
                            >
                              <i class="far fa-edit"></i>
                            </Button>
                            <Baja
                              idStatus={a._id}
                              is_active={a.activo}
                              URL_BAJA={process.env.REACT_APP_URL_ARTICULOS}
                            />
                          </div>
                        ) : (
                          <div>
                            <Button color="info" id="Editar" size="sm" disabled>
                              <i class="far fa-edit"></i>
                            </Button>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                }
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <Modal size="sm" isOpen={modalFoto} toggle={toggleFoto}>
        <ModalHeader toggle={toggleFoto}>
          <h4>Ficha Tecnica</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            {photo ? (
              <h6 style={{ textAlign: "center" }}>
                <img
                  // loading="lazy"
                  src={`${process.env.REACT_APP_URL_FOTO_CLOUDINARY}/image/upload/v${photo}/tuchArticulos/${idEditArticulo}.jpg`}
                  alt=""
                />
              </h6>
            ) : (
              <h4>No se ha subido una Ficha Tecnica....</h4>
            )}
          </Row>
        </ModalBody>
      </Modal>

      <Modal size="xxl" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>
            Editar Modelo {codigo} / {nombre}
          </h4>
        </ModalHeader>
        <ModalBody>
          <input type="hidden" value={clave} />

          {/* 🏷 Identificadores */}
          <div style={block}>
            <div style={sec}>🏷 Identificadores</div>
            <Row>
              <Col md={3}><Label>Codigo de Origen</Label><Input type="text" placeholder="Codigo" value={codigo} required onChange={(e) => setCodigo(e.target.value)} /></Col>
              <Col md={3}><Label>Codigo SAT</Label><Input type="text" placeholder="CodigoSAT" value={codigoSAT} required onChange={(e) => setCodigoSAT(e.target.value)} /></Col>
              <Col md={3}><Label>UPC</Label><Input type="text" placeholder="UPC" value={EAN} required onChange={(e) => setEAN(e.target.value)} /></Col>
              <Col md={3}><Label>Parent</Label><Input type="text" placeholder="Parent" value={SKU} required onChange={(e) => setSKU(e.target.value)} /></Col>
            </Row>
            <Row className="mt-2">
              <Col md={3}><Label>MLM</Label><Input type="text" placeholder="MLM" value={MLM} required onChange={(e) => setMLM(e.target.value)} /></Col>
              <Col md={3}><Label>Nombre</Label><Input type="text" placeholder="Nombre" value={nombre} required onChange={(e) => setNombre(e.target.value)} /></Col>
              <Col md={3}><Label>Variante / Modelo</Label><Input type="text" placeholder="modelo" value={modelo} required onChange={(e) => setModelo(e.target.value)} /></Col>
              <Col md={3}><Label>Piezas Por Caja</Label><Input type="number" min="0" step="any" placeholder="Piezas Por Caja" value={piezasPorCaja} required onChange={(e) => setPiezasPorCaja(e.target.value)} /></Col>
            </Row>
            <Row className="mt-2">
              <Col md={3}><Label>ASIN</Label><Input type="text" placeholder="ASIN" value={ASIN} onChange={(e) => setASIN(e.target.value)} /></Col>
              <Col md={3}><Label>WUPC (Walmart UPC)</Label><Input type="text" placeholder="WUPC" value={WUPC} onChange={(e) => setWUPC(e.target.value)} /></Col>
              <Col md={3}><Label>Imagenes</Label><Input type="select" value={imagenes} required onChange={(e) => setImagenes(e.target.value)}><option value="">Selecciona</option><option value="Si">Si</option><option value="No">No</option></Input></Col>
              <Col md={3}><Label>Link ML</Label><Input type="text" placeholder="LinkML" value={linkML} required onChange={(e) => setLinkML(e.target.value)} /></Col>
            </Row>
          </div>

          {/* 📁 Clasificación */}
          <div style={block}>
            <div style={sec}>📁 Clasificación</div>
            <Row>
              <Col md={3}>
                <Label>Linea</Label>
                <Input className="col-sm-12" type="select" value={selectedLineaEdit} required onChange={(e) => setSelectedLineaEdit(e.target.value)}>
                  <option value="0">Selecciona una Linea</option>
                  {lineas.sort((a, b) => (a.name > b.name ? 1 : -1)).map((a) => <option key={a._id} value={a._id}>{a.name}</option>)}
                </Input>
              </Col>
              <Col md={3}>
                <Label>Marca</Label>
                <Input className="col-sm-12" type="select" value={selectedMarcaEdit} required onChange={(e) => setSelectedMarcaEdit(e.target.value)}>
                  <option value="0">Selecciona una Marca</option>
                  {marcas.sort((a, b) => (a.name > b.name ? 1 : -1)).map((a) => <option key={a._id} value={a._id}>{a.name}</option>)}
                </Input>
              </Col>
              <Col md={3}>
                <Label>Categoria</Label>
                <Input className="col-sm-12" type="select" value={selectedFamiliaEdit} required onChange={(e) => setSelectedFamiliaEdit(e.target.value)}>
                  <option value="0">Selecciona una Categoria</option>
                  {familias.sort((a, b) => (a.name > b.name ? 1 : -1)).map((a) => <option key={a._id} value={a._id}>{a.name}</option>)}
                </Input>
              </Col>
              <Col md={3}>
                <Label>Proveedor</Label>
                <Input className="col-sm-12" type="select" value={selectedProveedorEdit} required onChange={(e) => setSelectedProveedorEdit(e.target.value)}>
                  <option value="0">Selecciona un Proveedor</option>
                  {proveedores.sort((a, b) => a.nombre_comercial > b.nombre_comercial ? 1 : -1).map((a) => <option key={a._id} value={a._id}>{a.nombre_comercial}</option>)}
                </Input>
              </Col>
            </Row>
          </div>

          {/* 💰 Costos y Precios */}
          <div style={block}>
            <div style={sec}>💰 Costos y Precios</div>
            <Row>
              <Col md={2}><Label>FOB USD</Label><Input type="number" placeholder="FOB USD" value={costoUSD} required onChange={(e) => setCostoUSD(e.target.value)} /></Col>
              <Col md={2}><Label>Costo MX</Label><Input type="number" placeholder="Costo MX" value={costoMX} required onChange={(e) => setCostoMX(e.target.value)} /></Col>
              <Col md={2}><Label>Venta</Label><Input type="number" placeholder="Venta" value={venta} required onChange={(e) => setVenta(e.target.value)} /></Col>
              <Col md={3}><Label>Stock Mínimo</Label><Input type="number" placeholder="StockMinimo" value={stockMinimo} required onChange={(e) => setStockMinimo(e.target.value)} /></Col>
              <Col md={3}><Label>Stock Máximo</Label><Input type="number" placeholder="StockMaximo" value={stockMaximo} required onChange={(e) => setStockMaximo(e.target.value)} /></Col>
            </Row>
            <div style={{ marginTop: 10 }}>
              <small style={{ color: "#6b7280", fontWeight: 600 }}>Precios Neto</small>
              <Row className="mt-1">
                {[["Lista 1", lista1, setLista1], ["Lista 2", lista2, setLista2], ["Lista 3", lista3, setLista3], ["Lista 4", lista4, setLista4]].map(([label, val, setter]) => (
                  <Col md={3} key={label}><Label>{label}</Label><Input type="number" min="0" step="any" value={val} required onChange={(e) => setter(e.target.value)} /></Col>
                ))}
              </Row>
            </div>
            <div style={{ marginTop: 10 }}>
              <small style={{ color: "#6b7280", fontWeight: 600 }}>Precios Bruto</small>
              <Row className="mt-1">
                {[["Lista 1", lista1Bruto, setLista1Bruto], ["Lista 2", lista2Bruto, setLista2Bruto], ["Lista 3", lista3Bruto, setLista3Bruto], ["Lista 4", lista4Bruto, setLista4Bruto]].map(([label, val, setter]) => (
                  <Col md={3} key={label}><Label>{label}</Label><Input type="number" min="0" step="any" value={val} required onChange={(e) => setter(e.target.value)} /></Col>
                ))}
              </Row>
            </div>
          </div>

          {/* 📐 Medidas */}
          <div style={block}>
            <div style={sec}>📐 Medidas</div>
            {[
              { label: "Producto", vals: [[largoProducto, setLargoProducto], [anchoProducto, setAnchoProducto], [altoProducto, setAltoProducto], [pesoProducto, setPesoProducto]] },
              { label: "Empaque",  vals: [[largoEmpaque, setLargoEmpaque], [anchoEmpaque, setAnchoEmpaque], [altoEmpaque, setAltoEmpaque], [pesoEmpaque, setPesoEmpaque]] },
              { label: "Master",   vals: [[largoMaster, setLargoMaster], [anchoMaster, setAnchoMaster], [altoMaster, setAltoMaster], [pesoMaster, setPesoMaster]] },
            ].map(({ label, vals }) => (
              <Row key={label} className="mb-2">
                <Col md={12}><small style={{ color: "#6b7280", fontWeight: 600, textTransform: "uppercase" }}>{label}</small></Col>
                {["Largo", "Ancho", "Alto", "Peso"].map((dim, i) => (
                  <Col md={3} key={dim}><Label>{dim}</Label><Input type="number" step="any" value={vals[i][0]} required onChange={(e) => vals[i][1](e.target.value)} /></Col>
                ))}
              </Row>
            ))}
          </div>

          <br />
          <h4>Variantes</h4>
          <Button
            type="button"
            size="sm"
            color="info"
            onClick={() =>
              setVariantesFields([
                ...variantesFields,
                { id: uuidv4(), nombre: "", ASIN: [], WUPC: [], MLM: [] },
              ])
            }
          >
            <i className="fas fa-plus"></i> Agregar Variante
          </Button>
          {variantesFields.length > 0 && (
            <Table borderless size="sm" style={{ marginTop: "8px" }}>
              <thead>
                <tr>
                  <th style={{ minWidth: 130 }}>Nombre</th>
                  <th>ASIN</th>
                  <th>WUPC</th>
                  <th>MLM</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {variantesFields.map((vf) => (
                  <tr key={vf.id} style={{ verticalAlign: "top" }}>
                    <td>
                      <Input
                        type="text"
                        placeholder="Variante"
                        value={vf.nombre}
                        onChange={(e) =>
                          setVariantesFields(
                            variantesFields.map((v) =>
                              v.id === vf.id ? { ...v, nombre: e.target.value } : v
                            )
                          )
                        }
                      />
                    </td>
                    {["ASIN", "WUPC", "MLM"].map((field) => (
                      <td key={field} style={{ minWidth: 160 }}>
                        <TagCellInputEdit
                          values={vf[field]}
                          placeholder={field}
                          onAdd={(val) => addTagEdit(vf.id, field, val)}
                          onRemove={(i) => removeTagEdit(vf.id, field, i)}
                        />
                      </td>
                    ))}
                    <td style={{ paddingTop: 6 }}>
                      <Button
                        type="button"
                        size="sm"
                        color="danger"
                        onClick={() =>
                          setVariantesFields(variantesFields.filter((v) => v.id !== vf.id))
                        }
                      >
                        <i className="fas fa-minus"></i>
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}

          <br />
          <Col md={6}>
            <Label>Foto</Label>
            <Input
              type="file"
              onChange={(e) => {
                setFile(e.target.files[0]);
              }}
            />
          </Col>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editArticulos}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modalDatos} toggle={toggleDatos}>
        <ModalHeader toggle={toggleDatos}>
          <h4>Actualiza Datos</h4>
        </ModalHeader>
        <ModalBody>
          <Col>
            <Input
              required
              type="file"
              name="file"
              id="file"
              onChange={(event) => importarArchivo(event)}
            />
          </Col>
        </ModalBody>
        {cargando ? (
          <ModalFooter>
            {validaBoton ? (
              <Button size="sm" color="success" onClick={actualizaDatos}>
                Guardar
              </Button>
            ) : (
              <Button size="sm" color="success" disabled>
                {/* <i className="fas fa-spinner fa-spin fa-2x me-2"></i> Cargando */}
                <i
                  className="fas fa-hourglass-half custom-spin fa-2x me-4"
                  style={{ marginRight: "10px" }}
                ></i>{" "}
                Cargando
              </Button>
            )}
          </ModalFooter>
        ) : undefined}
      </Modal>

      <Modal size="sm" isOpen={modalCostos} toggle={toggleCostos}>
        <ModalHeader toggle={toggleCostos}>
          <h4>Actualiza Costos</h4>
        </ModalHeader>
        <ModalBody>
          <Col>
            <Input
              required
              type="file"
              name="file"
              id="file"
              onChange={(event) => importarArchivoCostos(event)}
            />
          </Col>
        </ModalBody>
        {cargando ? (
          <ModalFooter>
            {validaBoton ? (
              <Button size="sm" color="success" onClick={actualizaCostos}>
                Guardar
              </Button>
            ) : (
              <Button size="sm" color="success" disabled>
                {/* <i className="fas fa-spinner fa-spin fa-2x me-2"></i> Cargando */}
                <i
                  className="fas fa-hourglass-half custom-spin fa-2x me-4"
                  style={{ marginRight: "10px" }}
                ></i>{" "}
                Cargando
              </Button>
            )}
          </ModalFooter>
        ) : undefined}
      </Modal>

      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>Progreso</h4>
        </ModalHeader>
        <ModalBody>
          <h4>
            {" "}
            Este proceso puede tardar varios segundos.
            <br />
            Por favor no cierre ni refresque su navegador.
          </h4>
          <br />
          <div className="progreso">
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
          </div>
        </ModalBody>
      </Modal>

<Modal size="xxl" isOpen={modalCotizador} toggle={toggleCotizador}>
  <ModalHeader toggle={toggleCotizador}>
    <h4>Cotizador</h4>
  </ModalHeader>
  <ModalBody>
<Table bordered size="sm" responsive className="cotizador-table">
      <thead>
        <tr>
          <th>SKU</th>
          <th>PIEZAS POR CAJA</th>
          <th>CBM/CAJA</th>
          <th>PRECIO FOB</th>
          <th>CBM CONTENEDOR</th>
          <th>CAJAS POR CONTENEDOR</th>
          <th>PIEZAS POR CONTENEDOR</th>
          <th>FLETE MARITIMO</th>
          <th>IMPUESTOS</th>
          <th>TOTAL IMPORTACION</th>
          <th>COSTO IMPORTACION POR PIEZA</th>
          <th>COSTO TOTAL PRODUCTO DLLS</th>
          <th>TIPO DE CAMBIO</th>
          <th>COSTO TOTAL PRODUCTO PESOS</th>
          <th>GASTOS</th>
          <th>VENTA</th>
          <th>ENVIO</th>
          <th>COMISION</th>
          <th>TE PAGAN</th>
          <th>UTILIDAD</th>
          <th>MARGEN</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          {/* CAMPOS ROJOS (CAPTURA) */}
          <td>
            <Input
              bsSize="sm"
              name="sku"
              value={cotizador.sku}
              onChange={handleChangeCotizador}
              style={{ backgroundColor: "#ffcccc" }}
            />
          </td>
          <td>
            <Input
              bsSize="sm"
              type="number"
              name="piezasPorCaja"
              value={cotizador.piezasPorCaja}
              onChange={handleChangeCotizador}
              style={{ backgroundColor: "#ffcccc" }}
            />
          </td>
          <td>
            <Input
              bsSize="sm"
              type="number"
              step="0.0001"
              name="cbmCaja"
              value={cotizador.cbmCaja}
              onChange={handleChangeCotizador}
              style={{ backgroundColor: "#ffcccc" }}
            />
          </td>
          <td>
            <Input
              bsSize="sm"
              type="number"
              step="0.01"
              name="precioFob"
              value={cotizador.precioFob}
              onChange={handleChangeCotizador}
              style={{ backgroundColor: "#ffcccc" }}
            />
          </td>
          <td>
            <Input
              bsSize="sm"
              type="number"
              step="0.01"
              name="cbmContenedor"
              value={cotizador.cbmContenedor}
              onChange={handleChangeCotizador}
              style={{ backgroundColor: "#ffcccc" }}
            />
          </td>

          {/* CAMPOS AMARILLOS (FÓRMULAS) */}
          <td>
            <Input
              bsSize="sm"
              disabled
              value={cajasPorContenedorCotizador.toFixed(2)}
              style={{ backgroundColor: "#fff7a8" }}
            />
          </td>
          <td>
            <Input
              bsSize="sm"
              disabled
              value={piezasPorContenedorCotizador.toFixed(2)}
              style={{ backgroundColor: "#fff7a8" }}
            />
          </td>

          {/* ROJOS */}
          <td>
            <Input
              bsSize="sm"
              type="number"
              step="0.01"
              name="fleteMaritimo"
              value={cotizador.fleteMaritimo}
              onChange={handleChangeCotizador}
              style={{ backgroundColor: "#ffcccc" }}
            />
          </td>
          <td>
            <Input
              bsSize="sm"
              type="number"
              step="0.01"
              name="impuestos"
              value={cotizador.impuestos}
              onChange={handleChangeCotizador}
              style={{ backgroundColor: "#ffcccc" }}
            />
          </td>

          {/* AMARILLOS */}
          <td>
            <Input
              bsSize="sm"
              disabled
              value={totalImportacionCotizador.toFixed(2)}
              style={{ backgroundColor: "#fff7a8" }}
            />
          </td>
          <td>
            <Input
              bsSize="sm"
              disabled
              value={costoImportacionPorPiezaCotizador.toFixed(4)}
              style={{ backgroundColor: "#fff7a8" }}
            />
          </td>
          <td>
            <Input
              bsSize="sm"
              disabled
              value={costoTotalProductoDllsCotizador.toFixed(4)}
              style={{ backgroundColor: "#fff7a8" }}
            />
          </td>

          {/* ROJO */}
          <td>
            <Input
              bsSize="sm"
              type="number"
              step="0.01"
              name="tipoCambio"
              value={cotizador.tipoCambio}
              onChange={handleChangeCotizador}
              style={{ backgroundColor: "#ffcccc" }}
            />
          </td>

          {/* AMARILLOS */}
          <td>
            <Input
              bsSize="sm"
              disabled
              value={costoTotalProductoPesosCotizador.toFixed(2)}
              style={{ backgroundColor: "#fff7a8" }}
            />
          </td>
          <td>
            <Input
              bsSize="sm"
              disabled
              value={gastosCotizador.toFixed(2)}
              style={{ backgroundColor: "#fff7a8" }}
            />
          </td>

          {/* ROJOS */}
          <td>
            <Input
              bsSize="sm"
              type="number"
              step="0.01"
              name="venta"
              value={cotizador.venta}
              onChange={handleChangeCotizador}
              style={{ backgroundColor: "#ffcccc" }}
            />
          </td>
          <td>
            <Input
              bsSize="sm"
              type="number"
              step="0.01"
              name="envio"
              value={cotizador.envio}
              onChange={handleChangeCotizador}
              style={{ backgroundColor: "#ffcccc" }}
            />
          </td>
          <td>
            <Input
              bsSize="sm"
              type="number"
              step="0.01"
              name="comision"
              value={cotizador.comision}
              onChange={handleChangeCotizador}
              style={{ backgroundColor: "#ffcccc" }}
            />
          </td>

          {/* AMARILLOS */}
          <td>
            <Input
              bsSize="sm"
              disabled
              value={tePaganCotizador.toFixed(2)}
              style={{ backgroundColor: "#fff7a8" }}
            />
          </td>
          <td>
            <Input
              bsSize="sm"
              disabled
              value={utilidadCotizador.toFixed(2)}
              style={{ backgroundColor: "#fff7a8" }}
            />
          </td>
          <td>
            <Input
              bsSize="sm"
              disabled
              value={(margenCotizador * 100).toFixed(2) + " %"}
              style={{ backgroundColor: "#fff7a8" }}
            />
          </td>
        </tr>
      </tbody>
    </Table>
  </ModalBody>
</Modal>

      {loader}
    </>
  );
}

function TagCellInputEdit({ values, placeholder, onAdd, onRemove }) {
  const [inputVal, setInputVal] = React.useState("");

  function handleKey(e) {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      if (inputVal.trim()) { onAdd(inputVal.trim()); setInputVal(""); }
    }
  }
  function handleBlur() {
    if (inputVal.trim()) { onAdd(inputVal.trim()); setInputVal(""); }
  }

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 4, alignItems: "center",
      border: "1px solid #ced4da", borderRadius: 4, padding: "4px 6px", minHeight: 34, cursor: "text" }}>
      {values.map((v, i) => (
        <span key={i} style={{ background: "#dbeafe", color: "#1e3a8a", padding: "1px 8px",
          borderRadius: 12, fontSize: "0.74rem", fontWeight: 600,
          display: "flex", alignItems: "center", gap: 4, whiteSpace: "nowrap" }}>
          {v}
          <button type="button" onClick={() => onRemove(i)}
            style={{ background: "none", border: "none", cursor: "pointer",
              color: "#1e3a8a", padding: 0, lineHeight: 1, fontSize: "0.85rem", fontWeight: 700 }}>
            ×
          </button>
        </span>
      ))}
      <input type="text" placeholder={values.length === 0 ? `+ ${placeholder}` : "+"}
        value={inputVal} onChange={(e) => setInputVal(e.target.value)}
        onKeyDown={handleKey} onBlur={handleBlur}
        style={{ border: "none", outline: "none", fontSize: "0.78rem",
          minWidth: 60, flex: 1, background: "transparent" }} />
    </div>
  );
}

export default ListadoArticulos;
